import script from "./OrderSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderSummary.vue?vue&type=script&setup=true&lang=ts"

import "./OrderSummary.vue?vue&type=style&index=0&id=2ca0867a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ca0867a"]])

export default __exports__